"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFromVersion = void 0;
const ISO_DATE_INTERVAL = {
    day: {
        lower: 6,
        upper: 8,
    },
    hour: {
        lower: 8,
        upper: 10,
    },
    milisecond: 14,
    minute: {
        lower: 10,
        upper: 12,
    },
    month: {
        lower: 4,
        upper: 6,
    },
    second: {
        lower: 12,
        upper: 14,
    },
    year: {
        lower: 0,
        upper: 4,
    },
};
/**
 * It receives a ISO date string and returns a Date object.
 * This is responsible to handle the menu-service return on
 * POST api/v3/plus
 *
 * @param {string|number} date - ISO String without non-digit delimiters
 * @returns {Date}
 */
const getDateFromVersion = (date) => {
    const dateString = String(date);
    const [year, month, day, hour, minutes, seconds, miliseconds] = [
        dateString.slice(ISO_DATE_INTERVAL.year.lower, ISO_DATE_INTERVAL.year.upper),
        dateString.slice(ISO_DATE_INTERVAL.month.lower, ISO_DATE_INTERVAL.month.upper),
        dateString.slice(ISO_DATE_INTERVAL.day.lower, ISO_DATE_INTERVAL.day.upper),
        dateString.slice(ISO_DATE_INTERVAL.hour.lower, ISO_DATE_INTERVAL.hour.upper),
        dateString.slice(ISO_DATE_INTERVAL.minute.lower, ISO_DATE_INTERVAL.minute.upper),
        dateString.slice(ISO_DATE_INTERVAL.second.lower, ISO_DATE_INTERVAL.second.upper),
        dateString.slice(ISO_DATE_INTERVAL.milisecond),
    ];
    const datePart = [year, month, day].join('-');
    const timePart = [hour, minutes, seconds].join(':');
    const isoDateString = `${datePart}T${timePart}.${miliseconds}Z`;
    return new Date(isoDateString);
};
exports.getDateFromVersion = getDateFromVersion;
//# sourceMappingURL=get-date-from-version.js.map